<script lang="ts" setup>
import {ref} from "vue";
import { type NotificationDto } from '@/client/types.gen';
import { useNotificationStore } from '@/stores/notificationStore'

const emit = defineEmits(["refresh"])
const props = defineProps({
  notification: {type: Object as () => NotificationDto},
})
const notificationStore = useNotificationStore()
const visible = ref(false);
const toggleValue = () => {
  if (props.notification?.issueId != null)
    visible.value = !visible.value;
}

const startX = ref(0);
const currentX = ref(-80);
const deleteThreshold = 155; // auto delete swipe distance
const seenThreshold = 5; 
const item = ref()
const swiping = ref(false)


function startSwipe(e:any) {
  startX.value = e.clientX;
  currentX.value = -80;
  swiping.value = true;
  setTimeout(() => seenItem(), 300);
}

function swipe(e:any) {
  if (!swiping.value) return;
  if (e.clientX - startX.value < -160) return;
  if (e.clientX - startX.value > 1) return;

  currentX.value = e.clientX - startX.value;
}

function endSwipe() {
  if (currentX.value < -deleteThreshold) {
    deleteItem();
  }
  if (currentX.value > -seenThreshold) {
    seenItem();
  }
  currentX.value = -80
  swiping.value = false;
}

async function seenItem() {
  await notificationStore.seenNotification(props.notification!.id!)
  emit("refresh");
}
async function deleteItem() {
  await notificationStore.deleteNotification(props.notification!.id!)
  emit("refresh");
}
</script>

<template>
  <div 
    :ref="item"
    :style="{transform: 'translateX('+currentX+'px)'}"
    class="list-item"
    @pointerdown="startSwipe($event)"
    @pointermove="swipe($event)"
    @pointerup="endSwipe()"
    @pointercancel="endSwipe()"
  >
    <div class="seen">
      <i class="fa fa-eye-slash"></i>
    </div>
    <div class="content" :class="{'unseen':props.notification?.seenOn == null}">
      <div style="display: flex; flex-direction: row; margin-top: 25px; cursor: pointer" @click="toggleValue()">
        <div>
          &nbsp;<i class="fa fa-triangle-exclamation"></i>
        </div>
        <div style="display: flex; flex-direction: column; width: 100%; margin-left: 10px; position: relative;">
          <el-text style="width: 100%; font-size: 20px; line-height: 20px">{{ props.notification?.message }}</el-text>
          <el-text style="width: 100%; margin-top: 10px">{{ `${new Date(props.notification!.createdOn!).toDateString()} ${new Date(props.notification!.createdOn!).toLocaleTimeString()}` }}</el-text>

          <div class="float">
            <i title="Issue resolved" v-if="props.notification?.actioned" class="fa fa-check"></i>
            <i title="Issue was seen" v-if="props.notification?.seen" class="fa fa-eye"></i>
            <i title="Issue has comments" v-if="props.notification?.comments != null && props.notification?.comments?.length > 0" class="fa fa-comment"></i>
          </div>
        </div>
      </div>
      <div v-if="visible" class="comments">
        <div class="comment" v-for="n in notification?.comments" v-bind:key="n" v-html="n">
        </div>
      </div>
    </div>
    <div class="delete">
      <i class="fa fa-trash"></i>
    </div>
  </div>
</template>

<style scoped>
.float{
  position: absolute;
  top: 5px;
  right: 10px;
  color: #5d5d5d;
  font-size: .8em;
}
.float i{
  margin-left: 5px;
}

.list-item{
  position: relative;
  background: #fff;
  
  /*padding-bottom: 10px;*/
  touch-action: pan-y;
  display: flex;
  flex-wrap:nowrap;
  transition: all 0.3s linear;
  width: 100%;
}
.content{
  min-width: 100%;
  max-width: 100%;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.unseen{
  background: #c3e6ff;
}
.delete {
  background: rgb(179, 30, 30);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  border-bottom: 1px solid #5d5d5d;
}
.seen{
  background: rgb(30, 57, 179);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  border-bottom: 1px solid #5d5d5d;
}

.comments{
  padding: 5px;
}
.comment{
  padding: 5px;
  margin-left: 25px;
  color: #5d5d5d;
}
</style>
